
import { useEffect, useState } from 'react';
import { Footer } from './Footer';
import Header from './Header';
import { ScrollToTop } from './ScrollTop'
import SettingIco from './SettingIco';

export const MainContainer = ({ children, page }) => {
    const [hashAccess, setHashAccess] = useState(false)

    useEffect(() => {
        const savedAccess = localStorage.getItem('acrfiAccess');
        const accessTime = localStorage.getItem('acrfiAccessTime');

        if (savedAccess === 'true' && accessTime) {
            const now = Date.now();
            const diff = now - parseInt(accessTime, 10);
            const tenMinutes = 10 * 60 * 1000;

            if (diff < tenMinutes) {
                setHashAccess(true);
            } else {
                localStorage.removeItem('acrfiAccess');
                localStorage.removeItem('acrfiAccessTime');
                setHashAccess(false);
            }
        }
    }, []);


    return (
        <div className='flex flex-col h-screen'>
            <Header page={page} />
            <div className="">
                {page === 'ADMIN' && hashAccess === false ? (
                    <div className='bg-red-500 text-white text-center py-20 mt-52' onClick={() => console.log(hashAccess)}>
                        SORRY YOU DON'T HAVE ACCESS TO THIS PAGE. PLEASE CONTACT THE ADMINISTRATOR.
                    </div>
                ) : children}

            </div>
            <ScrollToTop />
            <SettingIco />
            <Footer setHashAccess={setHashAccess} />
        </div>


    );
};